import { Link } from "@/components/common/Link";
import { useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Box } from "lucide-react";
export default function TradeAccountBanner() {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("opacity-100", "translate-y-0");
          entry.target.classList.remove("opacity-0", "translate-y-6");
        }
      });
    }, {
      threshold: 0.15
    });
    if (contentRef.current) observer.observe(contentRef.current);
    if (imageRef.current) observer.observe(imageRef.current);
    return () => observer.disconnect();
  }, []);
  const features = ["Trade Discount", "Credit Account*", "BDM Support", "Free Sample Box", "Trade Directory Profile"];
  return <section ref={sectionRef} className="dark bg-background relative overflow-hidden">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700;900&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="absolute inset-0 pointer-events-none select-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-lg bg-primary/5 blur-[120px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-lg bg-primary/10 blur-[100px]" />
      </div>

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 min-h-[580px]">
        <div ref={imageRef} className="relative order-1 lg:order-2 opacity-0 translate-y-6 transition-all duration-700 ease-out min-h-[300px] lg:min-h-full">
          <div className="absolute inset-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Trade-Account_Banner-desktop-1.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Trade-Account_Banner-desktop-1.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/LS_Trade-Account_Banner-desktop-1.webp-wvc-sizes" className="w-full h-auto object-cover w-full h-full" alt="Trade Account" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background/80 hidden lg:block" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent lg:hidden" />
          </div>

          <div className="absolute bottom-6 left-6">
            <span className="text-xs tracking-[0.3em] uppercase text-primary/80 font-medium" style={{
            fontFamily: "'DM Sans', sans-serif"
          }}></span>
          </div>
        </div>

        <div ref={contentRef} className="order-2 lg:order-1 bg-black flex flex-col justify-center px-8 py-14 lg:px-16 lg:py-20 opacity-0 translate-y-6 transition-all duration-700 ease-out delay-150">
          

          <h2 className="text-5xl lg:text-6xl xl:text-7xl font-black text-foreground leading-none mb-6 tracking-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }}><span className="text-primary" data-ast-id="f:/src/pages/ContactUs/sections/TradeAccountBanner.tsx|sig:p8yc2l" data-ast-start="3530" data-ast-end="3700"><font color="#f0ece6">Get in Touch</font></span></h2>

          <div className="w-12 h-[2px] bg-primary mb-7" />

          <p className="text-muted-foreground text-base lg:text-lg leading-relaxed mb-3 max-w-md" style={{
          fontFamily: "'DM Sans', sans-serif"
        }}>Email<div>Phone<div><Link to="tel:447459276538" className="hover:text-primary transition-colors">+44 7459 276538</Link></div><div>Monday – Friday, 8:00am – 5:00pm</div><div><br /></div></div><div><br /></div></p>

          

          

          <div>
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 active:scale-95 transition-all duration-200 px-10 py-5 text-sm tracking-[0.25em] uppercase font-semibold shadow-lg shadow-primary/20 hover:shadow-primary/40" style={{
            fontFamily: "'DM Sans', sans-serif"
          }}>
              
            </Button>
          </div>
        </div>
      </div>

      <div className="absolute left-0 top-0 bottom-0 w-[2px] bg-gradient-to-b from-transparent via-primary/30 to-transparent hidden lg:block" />
    </section>;
}